export default __webpack_public_path__ + "static/media/profile_img.96bc0ff2.jpg";